// Dev fixtures — the 8 frozen design datasets, loaded for the passport harness.
// These stand in for live wizard input until Track B wiring exists. Each file
// carries `input` (wizard sliders/text), a frozen `system1`, and — where a live
// judge run was frozen — `system2`.

const modules = import.meta.glob('../../docs/design-datasets/runs/*.json', { eager: true });

export const DATASETS = Object.entries(modules)
  .map(([path, mod]) => {
    const data = mod.default ?? mod;
    const id = path.split('/').pop().replace(/\.json$/, '');
    return { id, data };
  })
  .sort((a, b) => a.id.localeCompare(b.id));
